var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card p-1"},[_c('b-form-datepicker',{attrs:{"locale":"th"},model:{value:(_vm.test),callback:function ($$v) {_vm.test=$$v},expression:"test"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }